// import "./header.css";
import Button from "../../Components/baseComponents/Button/Button";
import { useHistory } from "react-router-dom";
import useStyles from "./useStyles";
import {memo} from "react";

export const StylizedMenuItem = memo((props) => {
    const {name, link, active, disabled, icon:IconComponent, renderComponent} = props;
    const history = useHistory();

    const classes = useStyles()

    const onClickHeader = ()=>{
        // ссылка может отсутствовать !!!
        link && history.push(link);
    }

    return (
        <div
            className={`${classes.topmenuItem} ${active ? 'active' : ''}`}
            onClick={!disabled && onClickHeader}
        >
            {IconComponent && <div
                className={classes.iconWrapper}><IconComponent/>
            </div>}

            <Button
                disabled={disabled}
                className={`topmenuItemBtn ${active ? 'active' : ''}`}
            >
                {name}
            </Button>
            {renderComponent && renderComponent}
        </div>
    )
})